import { render, staticRenderFns } from "./IdentificationLogStaff.vue?vue&type=template&id=90514e50&scoped=true&"
import script from "./IdentificationLogStaff.vue?vue&type=script&lang=js&"
export * from "./IdentificationLogStaff.vue?vue&type=script&lang=js&"
import style0 from "./IdentificationLogStaff.vue?vue&type=style&index=0&id=90514e50&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90514e50",
  null
  
)

export default component.exports